import {keys} from 'ts-transformer-keys';

import {
    Images,
    Messages,
    Styles
} from '~/shared/src/utilities/dataExtraction';
import {Query} from '~/shared/src/utilities/query';
import {
    DataAggregator,
    DataDescriptor,
    ObjectDataDescriptor
} from '~/shared/src/utilities/dataStructure';
import {Condition} from '~/shared/src/utilities/condition';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


// CFG:MapDataSet
export type MapDataSet = {
    data : {
        id : number;
        key : string;
        name : string;

        active : boolean;
        connectToAggregateFunction? : DataAggregator;
        connectToAttributePath? : string;
        connectToQueryFieldName? : string;
        locationAggregateFunction? : DataAggregator;
        locationAttributePath? : string;
        locationQueryFieldName? : string;
        order : number;
        rootQueryFieldName? : string;
        searchGroup? : string;
        timeAggregateFunction? : DataAggregator;
        timeAttributePath? : string;
        timeQueryFieldName? : string;
    };
    query : Query;
    condition? : Condition;
    rootDataDescriptor? : DataDescriptor;
    connectToDataDescriptor? : DataDescriptor;
    locationDataDescriptor? : DataDescriptor;
    timeDataDescriptor? : DataDescriptor;
    dataDescriptors? : DataDescriptor[];
    images? : Images;
    messages? : Messages;
    permissions? : GroupPermissions;
    styles? : Styles;
};
export const mapDataSetDataProps = keys<MapDataSet['data']>();
export const mapDataSetProps = keys<MapDataSet>();
export const requiredMapDataSetProps = keys<RequiredOf<MapDataSet>>();
